import styled from 'styled-components';
import { Radio } from 'antd';
type Props = {};

const RadioButonStyle = styled(Radio.Button)`
  border: unset;
  width: 144px;
  font-size: 12px !important;
  text-align: left;
  display: inline-flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  height: 32px;
  &.ant-radio-button-wrapper:first-child {
    border-left: unset;
    border-radius: unset;
  }
  &.ant-radio-button-wrapper:not(:first-child)::before {
  }
  &.ant-radio-button-wrapper:last-child {
    border-radius: 0;
  }
  &.ant-radio-button-wrapper-checked {
    background: #2666bf;
    span {
      color: white;
    }
  }
  &:hover {
    cursor: pointer;
    background-color: #e5e5e5;
  }
  &:before {
    height: 20px !important;
    left: 0 !important;
    top: 8px !important;
    background-color: rgba(0, 0, 0, 0.05) !important;
    position: absolute;
    right: 0;
    display: block;
    box-sizing: content-box;
    width: 0.5px;
    padding: 1px 0;
    transition: background-color 0.3s;
    content: '';
  }
  &:after {
    background-color: rgba(0, 0, 0, 0.05);
    position: absolute;
    top: 8px;
    right: 0;
    display: block;
    box-sizing: content-box;
    width: 0.5px;
    height: 20px;
    padding: 1px 0;
    transition: background-color 0.3s;
    content: '';
  }
`;
const SectionStyle = styled.div<Props>`
  padding: 0 24px;
  height: 70vh;
  overflow-y: auto;
`;
const Container = styled.section`
  .footer {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    padding: 10px 15px;
    display: flex;
    justify-content: flex-end;
    button {
      background: linear-gradient(149.45deg, #3c82c0 0%, var(--border-color-base) 100%);
      color: white;
    }
  }
`;
const Header = styled.div`
  font-size: 18px;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  letter-spacing: 0;
  line-height: 27px;
`;
const ButtonSelectBranch = styled.div`
  border: none;
  margin-right: 30px;
  background: white;
`;
export { RadioButonStyle, SectionStyle, Container, Header, ButtonSelectBranch };
